export const MAX_NUMBER_AFTER_DECIMAL = 5;

export const MIN_QUANTITY_REQUIRED_MT = 15;
